
import { Vue, Options } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { maska } from 'maska'
import CLoading from '@/components/common/ui/CLoading.vue'
import { ACTION_INITIAL, ACTION_PUSH, ACTION_STORY } from '@/store/actions'
import { lastNMonth, now } from '@/utils/datetime'
import { constant } from '@/utils/constants'

@Options({
  components: { CLoading },
  directives: { maska },
  emits: ['update:closeModal'],
})
export default class UsageStoryModal extends Vue {
  @Prop()
  storyId!: string

  @Prop()
  campaignId!: string

  @Prop()
  campaignType!: string

  @Prop()
  modalVisible!: boolean

  loading = false
  stories: {
    app_id: string
    relationship_type: string
    story_id: string
    story_name: string
    created_at: string
    updated_at: string
  }[] = []

  get visible() {
    return this.modalVisible
  }

  set visible(value) {
    this.$emit('update:closeModal', value)
  }

  async fetchStoriesUsing() {
    if (this.campaignType === 'initial') {
      const res = await this.$store.dispatch(ACTION_INITIAL.LOAD_STORIES_USING, this.campaignId)
      this.stories = res.stories
    } else if (this.campaignType === 'push') {
      const res = await this.$store.dispatch(ACTION_PUSH.LOAD_STORIES_USING, this.campaignId)
      this.stories = res.stories
    } else {
      const res = await this.$store.dispatch(ACTION_STORY.CAMPAIGN_USAGE, this.storyId)
      this.stories = res.usage_stories
    }
  }

  getDetailsUrl(data) {
    return this.$router.resolve({
      name: 'story_details',
      params: {
        app_id: data.app_id,
        campaign_type: 'initial',
        story_id: data.story_id,
        from_date: lastNMonth(1),
        to_date: now(),
      },
    }).href
  }

  onDetails(event, data) {
    // Check if Ctrl (Windows) or Meta (Mac) is pressed
    if (event.ctrlKey || event.metaKey) {
      // Let the browser handle opening in a new tab
      return
    }
    // Otherwise, navigate programmatically
    event.preventDefault()

    this.goto('story_details', {
      app_id: data.app_id,
      campaign_type: 'initial',
      story_id: data.story_id,
      from_date: lastNMonth(1),
      to_date: now(),
    })
  }

  getEditUrl(data) {
    return this.$router.resolve({
      name: 'story_setting',
      params: {
        app_id: data.app_id,
        story_id: data.story_id,
        action_type: constant.ACTION_TYPE.EDIT,
      },
    }).href
  }

  onEdit(event, data) {
    // Check if Ctrl (Windows) or Meta (Mac) is pressed
    if (event.ctrlKey || event.metaKey) {
      // Let the browser handle opening in a new tab
      return
    }
    // Otherwise, navigate programmatically
    event.preventDefault()

    this.goto('story_setting', {
      app_id: data.app_id,
      story_id: data.story_id,
      action_type: constant.ACTION_TYPE.EDIT,
    })
  }

  goto(name: string, params = {}) {
    this.$router.push({
      name,
      params,
    })
  }

  onCancel() {
    this.visible = false
  }

  async created() {
    this.loading = true
    await this.fetchStoriesUsing()
    this.loading = false
  }
}
